// extracted by mini-css-extract-plugin
export default {"tabs":"ConfigTabs_tabs__1HR1-","tabs__panel":"ConfigTabs_tabs__panel__HEXiD"};